<template>
  <div style="position: relative;">
    <v-carousel
        :height="$vuetify.breakpoint.lgAndUp?'86vh':'auto'"
        hide-delimiter-background
        hide-delimiters
        :show-arrows="false"
        v-model="selectedImage"
        cycle
    >
      <v-carousel-item
          v-for="(item, i) in slider.topics"
          :key="i"
      >
       <v-img :src="item.photo_file" style="object-fit: fill" cover></v-img>
      </v-carousel-item>
    </v-carousel>
    <!--    <div>
          <div

              :style="{ backgroundImage: 'url(' + slider.banners[selectedImage].file + ')' }"
              :class="['slide-img']">
          </div>
        </div>-->

    <!-- <div class="slider-bottom-border">
      <img width="100%"
           height="100%"
           src="https://www.sageglass.com/sites/all/themes/sage/img/vBorder.png" alt="">
    </div> -->

    <div class="dots-box-position d-flex flex-row justify-center align-center ">
      <v-row>
        <v-col class="d-flex justify-center align-center">
          <div
              @click="selectedImage = index"
              class="d-flex flex-column justify-center align-center ma-2"
              :style="{'height': '12px','width': '12px', 'background-color':selectedImage===index? '#FCC300':'rgba(204,204,204,0.27)'}"
              v-for="(item,index) in slider.topics">

          </div>
        </v-col>
      </v-row>
    </div>

  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "TopSlider",
  data() {
    return {
      selectedImage: 0,
      colors: [
        'primary',
        'secondary',
        'yellow darken-2',
        'red',
        'orange',
      ],

    }
  },
  computed: {
    ...mapState({
      slider: state => state.homeManagement.slider,
    })
  },
  methods: {
    checkedBottomItem() {
      return this.slider.banners[this.slider.banners.length - 1].id === this.slider.banners[this.selectedImage].id
    },

    slideLoop() {
      if (this.checkedBottomItem()) {
        this.selectedImage = 0
      } else {
        this.selectedImage++;
      }
    },


  },

  created() {
    // setInterval(() => this.slideLoop(), 4000)
  },
}
</script>

<style scoped>
.triangle {
  clip-path: polygon(0 100%, 50% 0, 100% 100%);
}

.tran {
  opacity: 0 !important;
  transition: opacity 1.25s ease-out !important;
}


.slide-img {
  position: relative;
  transition: background 3s;
  height: 90vh;
}

.slider-bottom-border {
  position: absolute;
  bottom: -9px;
  width: 100%;
}

.dots-box-position {
  position: absolute;
  bottom: 30px;
  right: 0;
  left: 0;
  height: 60px;
}
</style>